import { isEmpty, startsWith } from 'lodash/fp';

const getUrlWithoutProtocol = (url = '') => url.replace(/^https?:\/\//, '');

const getRefererFromServer = (req) => ({
  get: () => req.get('referer'),
  isCurrentHost: () => {
    return (
      !isEmpty(req.get('referer')) &&
      startsWith(req.get('host'), getUrlWithoutProtocol(req.get('referer')))
    );
  },
});

const getRefererFromClient = () => ({
  get: () => document.referrer,
  isCurrentHost: () =>
    !isEmpty(document.referrer) &&
    startsWith(
      getUrlWithoutProtocol(window.location.origin),
      getUrlWithoutProtocol(document.referrer),
    ),
});

export default (...args) => {
  return __SERVER__
    ? getRefererFromServer(...args)
    : getRefererFromClient(...args);
};
